module.exports = __webpack_public_path__ + "img/011.4974e3ab.jpg";